import { Injectable, Output, EventEmitter } from "@angular/core";

/*
  Generated class for the ImageResizeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImageResizeProvider {
	constructor() { }

	async resizeImage(
		file: File,
		maxWidth: number,
		maxHeight: number
	): Promise<any> {
		return new Promise((resolve, reject) => {
			let image = new Image();
			image.src = URL.createObjectURL(file);
			image.onload = () => {
				let width = image.width;
				let height = image.height;

				let newWidth;
				let newHeight;

				if (width > height) {
					newHeight = height * (maxWidth / width);
					newWidth = maxWidth;
				} else {
					newWidth = width * (maxHeight / height);
					newHeight = maxHeight;
				}

				let canvas = document.createElement("canvas");
				canvas.width = newWidth;
				canvas.height = newHeight;

				let context = canvas.getContext("2d");

				context.drawImage(image, 0, 0, newWidth, newHeight);
				resolve(canvas.toDataURL());
			};
			image.onerror = reject;
		});
	}
}
